import ButtonComponent from '../Button'

import * as styles from './PageActionsButtonAddEntity.module.css'

import PlusIcon from '../../icons/plus.svg'

function PageActionsButtonAddEntity({
  Button = ButtonComponent.Contained,
  Icon = PlusIcon,
  ...restProps
}) {
  return (
    <Button
      {...restProps}
      beforeIconProps={{ Icon }}
      className={styles.button}
      textClassName={styles.buttonText}
    />
  )
}

export default PageActionsButtonAddEntity
